<template>
    <div>
        <module-title title="基本信息"></module-title>
        <div class="mine-news-box register_box">
            <div style="width: 590px; margin: 0 auto">
                <el-form
                    ref="form"
                    :model="form"
                    label-width="172px"
                    status-icon
                >
                    <el-form-item label="姓名" prop="userName">
                        <el-input
                            v-model="form.userName"
                            disabled="disabled"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="性别" prop="sex">
                        <el-radio-group v-model="form.sex" disabled="disabled">
                            <el-radio :label="0">男</el-radio>
                            <el-radio :label="1">女</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="用户名" prop="showName">
                        <el-input
                            v-model="form.showName"
                            disabled="disabled"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="手机" prop="mobile">
                        <el-input
                            v-model="form.mobile"
                            disabled="disabled"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱" prop="email">
                        <el-input
                            v-model="form.email"
                            disabled="disabled"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="身份证号" prop="idNumber">
                        <el-input
                            v-model="form.idNumber"
                            disabled="disabled"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="单位名称" prop="businessName">
                        <el-input
                            v-model="form.businessName"
                            disabled="disabled"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="服役地点" prop="fyLocation" v-if="form.isFby == '1'">
                        <el-input
                            v-model="form.fyLocation"
                            disabled="disabled"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="国企单位名称" prop="gqUnitName" v-if="form.isGqdwjl == '1'">
                        <el-input
                            v-model="form.gqUnitName"
                            disabled="disabled"
                        ></el-input>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import ModuleTitle from "@/components/common/moduleTitle/ModuleTitle";

import { PcCookie, Key } from "@/utils/cookie";

import { getUserNews } from "@/api/personal";
export default {
    components: { ModuleTitle },
    data() {
        return {
            disabled: false,
            form: {
                showName: "",
                sex: "",
                userName: "",
                mobile: "",
                email: "",
                idNumber: "",
            },
        };
    },
    created() {
        this.fetchUserNews();
    },
    methods: {
        //获取用户信息
        fetchUserNews() {
            const sessionId = PcCookie.get(Key.jsessIdKey);
            getUserNews(sessionId).then((res) => {
                if (res.errorCode === "2000") {
                    var data = res.body.data;
                    this.form.sex = parseInt(data.sex);
                    this.form.userName = data.userName;
                    this.form.showName = data.showName;
                    this.form.mobile = data.mobile;
                    this.form.email = data.email;
                    this.form.idNumber=data.idNumber;
                }
            });
        },
    },
};
</script>
<style>
.opcityReletive {
    position: relative;
}
.opcity i {
    color: #fff !important;
    font-size: 36px !important;
    line-height: 154px;
}
.opcity {
    position: absolute;
    width: 100%;
    height: 156px;
    background: rgba(0, 0, 0, 0.5);
    left: 0;
    top: 0;
    z-index: 99;
    text-align: center;
}
.photoBtn {
    display: block;
    margin: 18px auto 0;
    cursor: pointer;
}
.videoBox {
    width: 300px;
    height: 300px;
    background: #000;
    margin: 0 auto;
}
.closeBtn {
    padding-right: 16px;
    line-height: 50px;
    font-size: 14px;
    color: #737373;
    cursor: pointer;
}
#photoBox {
    position: fixed;
    left: 50%;
    top: 50%;
    margin: -200px 0 0 -165px;
    z-index: 99;
    width: 370px;
    height: 470px;
    background: #f5f5f5;
    border: solid 1px #c1c1c1;
}
.camera_outer {
    position: fixed;
    left: 0;
    top: 148px;
}
.el-upload-list--picture-card .el-upload-list__item-thumbnail {
    max-height: 100%;
    max-width: 100%;
    width: auto !important;
    height: auto !important;
    position: absolute;
    margin: auto;
    top: -9999px;
    left: -9999px;
    bottom: -9999px;
    right: -9999px;
}
.el-upload-list--picture-card .el-upload-list__item {
    width: calc(50% - 8px);
    height: 156px;
    position: relative;
}
.register_box .el-upload--text i {
    font-size: 28px;
    color: #8c939d;
}
.register_box .el-upload--text:hover {
    border-color: #b21f27;
}
.register_box .el-upload--text img {
    max-width: 100%;
    max-height: 100%;
}
.register_box .el-upload--text {
    width: 100%;
    height: 156px;
    line-height: 156px;
    background: #f4f4f4;
    border: 1px dashed #c0ccda;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
}
</style>
<style>
.register_box .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #b21f27;
}
.register_box .el-checkbox__input.is-focus .el-checkbox__inner,
.register_box .el-checkbox__inner:hover {
    border-color: #b21f27;
}
.register_box .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
    border-color: #b21f27;
    background: #b21f27;
}
.register_box .el-radio__inner:hover {
    border-color: #b21f27;
}
.register_box .el-radio__input.is-checked + .el-radio__label {
    color: #b21f27;
}
.register_box .el-radio__input.is-checked .el-radio__inner {
    border-color: #b21f27;
    background: #b21f27;
}
.register_box .el-radio-group .el-radio {
    margin-right: 32px;
}
.register_box .el-upload--picture-card:hover {
    border-color: #b21f27;
}
.register_box .el-input__inner:hover,
.register_box .el-input__inner:focus {
    border-color: #b21f27;
}
.register_box .el-radio {
    margin: 0;
}
.register_box .el-upload__tip {
    font-size: 14px;
    color: #9a9a9a;
    text-align: center;
}
.register_box .el-upload--picture-card .opcity {
    left: 0;
    width: 100%;
}
.register_box .el-upload--picture-card {
    width: 50%;
    height: 156px;
    line-height: 156px;
    background: #f4f4f4;
    position: relative;
}
.register_box .el-form-item__label {
    font-size: 18px;
    color: #000;
}
</style>
<style  scoped>
.register_btn {
    margin: 0 auto;
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 20px;
    color: #fff;
    width: 296px;
    border-radius: 25px;
    cursor: pointer;
    background: #b21f27;
}
.agreement_item {
    cursor: pointer;
}
.agreement {
    color: #f1848a;
}
.text {
    font-size: 26px;
    color: #000;
    line-height: 102px;
    text-align: center;
}
.register_box {
    width: 590px;
    margin: 0 auto;
}
</style>
<style  scoped>
.mine-news-box {
    width: 100%;
    overflow-y: auto;
    margin: 0 auto;
}
</style>
